<template>
	<div class="component-container">
		<!--bind DoorAlert to knockAnswered data and register listener for the alert to be clicked-->
		<DoorAlert
			:knockAnswered="knockAnswered"
			@onClickDoorAlert="onKnockAnswered">
		</DoorAlert>
			<transition name="delayEntryHalf1">
				<Person :currentPerson="currentPerson" v-show="knockAnswered"></Person>
			</transition>
			<transition name="delayEntry1">
				<div class="request" v-show="knockAnswered">
					<div>
						<p class="body" v-html="request"></p>
						<div class="requestBtn" :class="{doneTyping: doneTyping}">
							<template v-if="!answerSelected">
								<Button class="optionsBtn" :class="{loanOptionsVisible: loanOptionsVisible}" :action="seeLoanOptions">See Loan Options</Button>
							</template>
							<template v-else>
								<Button :action="goNext">Continue</Button>
							</template>
						</div>
					</div>
					<Hint	v-if="showHint"></Hint>
				</div>
			</transition>
			<transition name="cardSlide" appear>
			<div class="loanOptions" v-if="loanOptionsVisible">
				<div class="cards">
					<div class="card-holder"
						v-for="(option, index) in shuffledOptions"
						:key="index"
						@click="selectLoanOption(option, $event)">
						<div class="card" :class="{flipped: isFlipped}">
							<div class="card-flip">
								<!-- RETURNERS -->
								<div class="card-face front returner" v-if="isReturner">
									<img class="card-img" :src="game_config.loan_option_card_front" />
									<div class="look-back" :class="{show: answerSelected}">
										<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 12">
												<rect y="10" class="st0" width="3" height="2" fill="#646E93"/>
												<rect class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="2.5" y="2.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 7.5 -0.5)" class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="2.5" y="7.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 12.5 4.5)" class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="5" y="5" class="st0" width="3" height="2" fill="#646E93"/>
											</svg>
									</div>
									<div class="card-content">
										<div class="card-hover" v-show="!answerSelected"></div>
										<div class="card-term" v-html="option.return_option_front"></div>
										<div class="card-hover" v-show="!answerSelected"></div>
									</div>
								</div>
								<!-- PAYDAY LOANS -->
								<div class="card-face front payday" v-else-if="isPayday">
									<img class="card-img" :src="game_config.loan_option_card_front" />
									<div class="look-back" :class="{show: answerSelected}">
										<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 12">
												<rect y="10" class="st0" width="3" height="2" fill="#646E93"/>
												<rect class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="2.5" y="2.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 7.5 -0.5)" class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="2.5" y="7.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 12.5 4.5)" class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="5" y="5" class="st0" width="3" height="2" fill="#646E93"/>
											</svg>
									</div>
									<div class="card-content">
										<div class="card-hover" v-show="!answerSelected"></div>
										<div class="payday-content" v-html="option.payday_offer_copy"></div>
										<div class="card-hover" v-show="!answerSelected"></div>
									</div>
								</div>
								<!-- NORMAL LOANS -->
								<div class="card-face front" v-else>
									<img class="card-img" :src="game_config.loan_option_card_front" />
									<div class="look-back" :class="{show: answerSelected}">
											<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 12">
												<rect y="10" class="st0" width="3" height="2" fill="#646E93"/>
												<rect class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="2.5" y="2.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 7.5 -0.5)" class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="2.5" y="7.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 12.5 4.5)" class="st0" width="3" height="2" fill="#646E93"/>
												<rect x="5" y="5" class="st0" width="3" height="2" fill="#646E93"/>
											</svg>
									</div>
									<div class="card-content">
										<div class="card-hover" v-show="!answerSelected"></div>
										<div class="card-heading">MONTHLY PAYMENT</div>
										<div class="card-term">{{formatMoney(option.monthly_payment, 2)}}</div>
										<div class="card-heading">INTEREST</div>
										<div class="card-term">{{option.loan_interest_rate}}%</div>
										<div class="card-heading">TERM LENGTH</div>
										<div class="card-term">{{option.loan_term}} {{option.loan_term_unit}}</div>
										<div class="card-hover" v-show="!answerSelected"></div>
									</div>
								</div>
								<div class="card-face back">
									<div class="backContent" v-if="answerSelected">
										<img class="card-img" :src="cardBg(option.ranking)" />
										<div class="look-back" :class="{show: answerSelected}">
												<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 12">
													<rect y="10" class="st0" width="3" height="2" fill="#ffffff"/>
													<rect class="st0" width="3" height="2" fill="#ffffff"/>
													<rect x="2.5" y="2.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 7.5 -0.5)" class="st0" width="3" height="2" fill="#ffffff"/>
													<rect x="2.5" y="7.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 12.5 4.5)" class="st0" width="3" height="2" fill="#ffffff"/>
													<rect x="5" y="5" class="st0" width="3" height="2" fill="#ffffff"/>
												</svg>
										</div>
										<div class="card-heading">YOUR PROFIT</div>
										<template v-if="isReturner">
											<div class="card-term">{{calculateReturnerAdjustment(option)}}</div>
										</template>
										<template v-else-if="isPayday">
											<div class="card-term">{{formatMoney(option.fee, 2)}}</div>
										</template>
										<template v-else>
											<div class="card-term">{{formatMoney(option.interest, 2)}}</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</transition>
		</div>
</template>

<script>
import Button from '@/components/abstract/Button';
import DoorAlert from '@/components/abstract/DoorAlert';
import Hint from '@/components/abstract/Hint';
import Person from '@/components/abstract/Person';
import PrecisionRound from '@/mixins/precision-round';
import tracking from '@/mixins/tracking';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';
import { mapState } from 'vuex';

export default {
	name: 'Scene',
	mixins: [tracking, msEdgeImageSwap],
	data() {
		return {
			knockAnswered: false,
			loanOptionsVisible: false,
			answerSelected: false,
			isFlipped: false,
			doneTyping: false,
			calcReturnOptions: [null, null, null],
		};
	},
	components: {
		Button,
		DoorAlert,
		Hint,
		Person,
	},
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
		currentRequest() {
			return this.$store.state.gameArray[this.$store.state.level][this.$store.state.scene];
		},
		willBeReturner() {
			if (this.currentRequest.game_level > this.$store.state.level && this.currentRequest.is_returner) {
				return true;
			}
			return false;
		},
		isReturner() {
			if (this.currentRequest.game_level === this.$store.state.level) {
				return true;
			}
			return false;
		},
		returnerPrevAnswer() {
			return this.$store.getters.getReturnerPrevAnswer(this.currentRequest.id);
		},
		isPayday() {
			if (this.currentRequest.request_type === "Payday") {
				return true;
			}
			return false;
		},
		shuffledOptions() {
			let o;
			if (this.isReturner) {
				o = this.currentRequest.returner_options;
			} else if (this.isPayday) {
				o = this.currentRequest.payday_loan_options;
			} else {
				o = this.currentRequest.loan_options;
			}
			for (let j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[i -= 1], o[i] = o[j], o[j] = x);
			return o;
		},
		currentPerson() {
			return this.currentRequest.person;
		},
		request() {
			let s;
			if (this.isReturner) {
				s = this.currentRequest.return_message_copy;
			} else {
				s = this.currentRequest.request_copy;
			}
			s = s.replace("{{Name}}", this.$store.state.playerName);
			s = s.replace("{{$$$}}", `$${this.formatMoney(this.currentRequest.loan_amount, 0)}`);
			return this.typewriterPrep(s);
		},
		showHint() {
			return this.currentRequest.hint && this.loanOptionsVisible && !this.answerSelected;
		},
	},
	methods: {
		formatMoney(amt, decimal) { // add comma, $, -, & specified decimals
			let f = '';
			if (amt < 0) {
				f = Math.abs(amt);
				f = f.toFixed(decimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				f = `-$${f}`;
			} else {
				f = amt.toFixed(decimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				f = `$${f}`;
			}
			return f;
		},
		onKnockAnswered() {
			this.knockAnswered = true;
			this.$nextTick(() => {
				const to = setTimeout(() => {
					this.typewriterAnim();
					clearTimeout(to);
				}, 1300);
			});
		},
		typewriterPrep(str) {
			let newStr = str.split(' ').map((word) => {
				let temp = '';
				for (let i = 0; i < word.length; i += 1) {
					temp += `<span class="letter">${word.charAt(i)}</span>`;
				}
				return `<span class="nowrap">${temp}</span>`;
			}).join(' ');
			// Add requesters name to front of string
			newStr = `<span class="typed strong">${this.currentRequest.person.title.toUpperCase()}:<br /></span>${newStr}`;
			return newStr;
		},
		typewriterAnim() {
			let i = 0;
			const letterList = document.getElementsByClassName('letter');
			const speed = 20;
			const anim = setInterval(() => {
				if (i < letterList.length) {
					document.getElementsByClassName("letter")[i].classList.add('typed');
					i += 1;
				} else {
					clearInterval(anim);
					this.doneTyping = true;
				}
			}, speed);
		},
		seeLoanOptions() {
			this.loanOptionsVisible = true;
			// delay call so cards have time to appear before swaping out images (MS Edge is slow)
			setTimeout(() => {
				this.swapEdgeImages();
			}, 100);
		},
		cardBg(rank) {
			if (rank === 1) {
				return this.game_config.loan_option_card_back_correct;
			}
			return this.game_config.loan_option_card_back_incorrect;
		},
		selectLoanOption(selected, event) {
			// initial selection click, reveals all answers
			if (!this.answerSelected) {
				this.answerSelected = true;
				this.isFlipped = true;
				event.currentTarget.classList.add('selected');
				// save answer for when this person returns later
				if (this.willBeReturner) {
					this.$store.commit('addReturnerAnswer', { id: this.currentRequest.id, option: selected });
				}
				if (this.isReturner) {
					setTimeout(() => {
						// need this timeout so returner income has time to calculate as cards flip.
						this.$store.commit('updateTotalMoney', this.calcReturnOptions[selected.ranking - 1]);
					}, 1000);
				} else if (this.isPayday) {
					setTimeout(() => {
						this.$store.commit('updateTotalMoney', selected.fee);
						this.$store.commit('updatePaydayFees', selected.fee);
					}, 1000);
				} else {
					setTimeout(() => {
						this.$store.commit('updateTotalMoney', selected.interest);
					}, 1000);
				}
				// delay call so cards have time to appear before swaping out images if MS Edge
				setTimeout(() => {
					this.swapEdgeImages();
				}, 100);
				this.$store.commit('updateScore', selected.ranking);
				// track answer in GA
				let t = 'incorrect';
				if (selected.ranking === 1) {
					t = 'correct';
				}
				this.trackPageview(`${this.currentRequest.title}-${t}`, `/level-${this.$store.state.level + 1}/request-${this.$store.state.scene + 1}/${this.currentRequest.title}/${t}`);
			} else {
				// can click to toggle between loan options and answers by flipping cards
				event.currentTarget.getElementsByClassName("card")[0].classList.toggle('flipped');
			}
		},
		calculateReturnerAdjustment(cardOption) {
			// calculate score adjustment based on stored previous answer +- fees etc stored as selected interest.
			let adj = 0;
			let term = 0;
			let rate = 0;
			let newInterest = 0;
			switch (cardOption.recalculation_type) {
				/* Changed calculations to not subtract previous interest earned, just charge for fee or not. Original calcuations are here commented out */
			case '0': // payoff loan with no fee: - original interest
				adj = 0; // -(this.returnerPrevAnswer.option.interest);
				break;
			case '1': // payoff loan with fee: - original interest + fee
				adj = cardOption.fee_amount; // -(this.returnerPrevAnswer.option.interest) + cardOption.fee_amount;
				break;
			case '2': // same loan with fee: + fee only
				adj = cardOption.fee_amount;
				break;
			case '3': // increase interest rate:
				term = this.returnerPrevAnswer.option.loan_term; // existing term in number of months
				rate = this.returnerPrevAnswer.option.loan_interest_rate * cardOption.new_interest_rate; // rate * multiplier
				// console.log(`Old Rate: ${this.returnerPrevAnswer.option.loan_interest_rate}% multiplier:${cardOption.new_interest_rate}`);
				// console.log(`New Rate: ${rate}%`);
				newInterest = this.calcCompoundInterest(term, rate);
				adj = newInterest - this.returnerPrevAnswer.option.interest;
				break;
			case '4': // increase loan term:
				term = this.returnerPrevAnswer.option.loan_term * cardOption.new_loan_term; // term * multiplier
				rate = this.returnerPrevAnswer.option.loan_interest_rate; // rate
				// console.log(`Old Term: ${this.returnerPrevAnswer.option.loan_term} months multiplier:${cardOption.new_loan_term}`);
				// console.log(`New Term: ${term} months`);
				newInterest = this.calcCompoundInterest(term, rate);
				adj = newInterest - this.returnerPrevAnswer.option.interest;
				break;
			case '5': // no change: don't adjust anything
				adj = 0;
				break;
			default:
				adj = 0;
				break;
			}
			// console.log(`on flip Previous Interest: ${this.returnerPrevAnswer.option.interest}`);
			// console.log(PrecisionRound(adj, 0));
			this.calcReturnOptions[cardOption.ranking - 1] = adj;
			// console.log(this.calcReturnOptions);
			return this.formatMoney(adj, 0);
		},
		calcCompoundInterest(term, rate) {
			// compounded monthly, payback monthly
			const principle = this.currentRequest.loan_amount; // loan amount
			const compounded = 12; // Frequency compounded - monthly
			const apr = (rate / 100) / compounded;
			const months = term;
			// calc monthly payment
			const monthlyPayment = (principle * ((apr * ((1 + apr) ** months)) / (((1 + apr) ** months) - 1))).toFixed(2);
			// totalBalance = payment times term months
			const totalBalance = (monthlyPayment * months).toFixed(2);
			// interest = total payment minus principle
			const interest = (totalBalance - principle).toFixed(2);
			/* console.log(`Loan Amount: ${principle}`);
			console.log(`apr: ${apr} (${rate}%)`);
			console.log(`Term: ${months} months`);
			console.log(`totalBalance: ${totalBalance}`);
			console.log(`monthlyPayment: ${monthlyPayment}`);
			console.log(`interestPaid: ${interest}`); */
			return PrecisionRound(interest, 2);
		},
		goNext() {
			this.loanOptionsVisible = false;
			if (this.isReturner && this.currentRequest.follow_up_email === true) {
				this.$router.push({ name: 'Special', params: { id: this.currentRequest.special_email, person: this.currentPerson } });
			} else if (this.currentRequest.request_type !== "Random" && this.currentRequest.follow_up_email === true) {
				this.$router.push({ name: 'Special', params: { id: this.currentRequest.special_email, person: this.currentPerson } });
			} else {
				this.$store.commit('incrementScene');
			}
		},
	},
	mounted() {
		this.swapEdgeImages();
		// tracks first component use
		this.trackPageview(`${this.currentRequest.title}`, `/level-${this.$store.state.level + 1}/request-${this.$store.state.scene + 1}/${this.currentRequest.title}`);
	},
};
</script>
<style lang="scss">
.typed{
	color: black;
}
.cards{
	width: 100%;
	height: 100%;
	bottom: 0;
	position: absolute;
	display: flex;
	align-items: flex-end;
	justify-content: space-around;
	flex-direction: row;
	.card-holder{
		width: 32%;
		height: 70%;
		perspective: 0;
		-ms-transform: perspective(0px);
		position: relative;
		cursor: pointer;
		&.selected{
			transition: transform 1s ease-in-out 0s;
			transform: translateY(-100px);
			@include breakpoint(md){
				transform: translateY(-50px);
			}
		}
		.card{
			width: 100%;
			height: 100%;
			transform-style: preserve-3d;
			perspective: 1000px;
			-ms-transform: perspective(1000px);
			cursor: pointer;
			position: relative;
			&:hover{
				& .card-hover{
					background-color: #7f8db1;
				}
			}
			& .card-flip{
				transition: transform 1s ease-in-out 0s;
				position: relative;
				width: 100%;
				height: 100%;
			}
			&.flipped {
				& .front{
					transform: rotateY(180deg);
					.card-content{
						opacity: 0;
					}
				}
				& .back {
					transform: rotateY(0deg);
				}
				//transform: rotateY(180deg);
			}
		}
		.card-face{
			position: absolute;
			width: 100%;
			height: 100%;
			backface-visibility: hidden;
			cursor: pointer;
			font-size: 19px;
			transition: transform 1s ease-in-out 0s;
			transform: rotateY(0deg);
			top: 0;
			left: 0;
			transform-style: preserve-3d;
			@include breakpoint(lg){
				font-size: 16px;
			}
			@include breakpoint(md){
				font-size: 15px;
			}
			@include breakpoint(sm){
				font-size: 14px;
			}
			@include breakpoint(xsm){
				font-size: 12px;
			}
			& .card-content{
				width: 100%;
				height: 100%;
				position: relative;
				display: flex;
				text-align: center;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				opacity: 1;
				transition: opacity 0s ease-in-out 0.5s; // stop flash of front of card in chrome when it flips
				pointer-events: none;
			}
			&.front{
				cursor: pointer;
				padding: 0 8%;
				transform: rotateY(0deg);
				z-index: 2;
			}
			&.back {
				transform: rotateY(-180deg);
				cursor: pointer;
				& .backContent{
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					color: white;
					padding: 15% 8% 0;
					& .card-term{
						line-height: 1.5em;
					}
				}
			}
			.look-back{
				width: 12px;
				height: 18px;
				position: absolute;
				top: 10%;
				right: 10%;
				cursor: pointer;
				opacity: 0;
				transition: opacity 0s ease-out 1s;
				@include breakpoint(sm){
					top: 8%;
					right: 10%;
					width: 8px;
					height: 10px;
				}
				&.show{
					opacity: 1;
				}
				&:hover{
					transform: scale(1.2);
				}
			}
			.card-img{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: block;
			}
			.card-hover{
				height: 2.5%;
				width: 70%;
				background-color: #ecedee;
				display: inline-block;
				transition: all .2s;
				margin: 5px 0;
				@include breakpoint(md){
					width: 80%;
					&:last-of-type{
						margin: 2px 0 0 0;
					}
					&:nth-child(2){
						margin: 0 0 4px 0;
					}
				}
				@include breakpoint(sm){
					display: none;
				}
			}
			& .card-heading{
				letter-spacing: normal;
				font-size: 0.75em;
				margin-top: .75em;
				&:nth-child(3){
					margin-top: 0;
				}
				@include breakpoint(md){
					margin-top: .5em;
				}
				@include breakpoint(sm){
					&:nth-child(3){
						margin-top: 7px;
					}
				}
			}
			& .card-term{
				font-size: 1.5em;
				line-height: 1em;
				width: 100%;
				text-align: center;
				@include breakpoint(md){
					font-size: 1.2em;
				}
				@include breakpoint(sm){
					font-size: 1.1em;
				}
			}
			& .payday-content{
				width: 100%;
				height: auto;
			}
			&.returner .card-term,
			&.payday .card-text{
				font-size: 1.25em;
				line-height: 1.2em;
				padding: 6px 0;
				width: 100%;
				@include breakpoint(md){
					font-size: 1.15em;
					line-height: 1em;
					padding: 1px 0;
				}
				@include breakpoint(sm){
					font-size: 1.1em;
					line-height: 1em;
				}
				@include breakpoint(xs){
					font-size: 0.975em;
				}
			}
			&.payday .card-heading{
				&:nth-child(3){
					margin-top: 0.75em;
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
	@import '../../assets/styles/utilities/**/*.scss';
	.delayEntry1-enter-active {
		transition: opacity 0s linear 1s;
	}
	.delayEntryHalf1-enter-active {
		transition: opacity 0s linear 0.5s;
	}
	.delayEntry1-enter, .delayEntry1-leave-to, .delayEntry1-leave, .delayEntryHalf1-enter, .delayEntryHalf1-leave-to, .delayEntryHalf1-leave, .delayEntry1-leave-active, .delayEntryHalf1-leave-active {
		opacity: 0;
	}
	.cardSlide-enter-active, .cardSlide-leave-active {
		transition: all 1s;
	}
	.cardSlide-enter-to, .cardSlide-leave {
		transform: translateY(0);
	}
	.cardSlide-enter, .cardSlide-leave-to {
		transform: translateY(100%);
	}
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		text-align: left;
	}
	.act{
		width: 100%;
		height: 100%;
	}
	.request{
		width: 40%;
		height: auto;
		min-height: 20%;
		overflow-y: auto;
		background-color: $purple;
		box-shadow: 0 0 0 5px black, 0 0 0 10px $purple, 0 0 0 15px black;
		display: inline-block;
		top: 11.5%;
		left: 55%;
		position: absolute;
		text-align: left;
		padding: 0.5% 1.5%;
		color: #808bb2;
		z-index: 100;
		overflow: hidden;
		@include breakpoint(sm){
			padding: 0.5% 1.5%;
			box-shadow: 0 0 0 3px black, 0 0 0 6px $purple, 0 0 0 9px black;
		}
		& .body{
			font-size: 1.5em;
			line-height: 1.4em;
			@include breakpoint(lg){
				font-size: 1.375em;
				line-height: 1.3em;
			}
			@include breakpoint(md){
				margin: 15px auto;
				font-size: 1.125em;
				line-height: 1.3em;
			}
			@include breakpoint(sm){
				margin: 10px auto;
				font-size: 1.0625em;
				line-height: 1.25em;
			}
			@include breakpoint(xsm){
				font-size: 0.9375em;
				line-height: 1.2em;
			}
			@include breakpoint(xs){
				font-size: .875em;
				line-height: 1.2em;
			}
		}
	}
	.requestBtn{
		opacity: 0;
		visibility: hidden;
		transition: visibility 0s linear 0s, opacity 300ms;
		&.doneTyping{
			opacity: 1;
			visibility: visible;
		}
	}
	.optionsBtn{
		opacity: 0;
		visibility: hidden;
		transition: visibility 0s linear 300ms, opacity 300ms;
		.doneTyping &{
			opacity: 1;
			visibility: visible;
		}
		&.loanOptionsVisible{
			opacity: 0;
			visibility: hidden;
		}
	}
	.loanOptions{
		width: 55%;
		height: 57%;
		top: 46.5%;
		left: 5%;
		position: absolute;
		z-index: 2000;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/Scene.vue